function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("image", {
  x: 10,
  y: 12,
  width: 76,
  height: 72,
  xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABICAYAAABcBhM9AAACcElEQVR4nO3YzUtUURzG8eecuTqNloshJYReMKhV6CJrHZitQlq5q/6HopdVf0H1FwRtXbVxIwhFOIIQ5uBKaBERjIEJFTpMMvfELSZycJh5Zu45NuPz2Qkzv3vul+N9GYOAdqcnT7sqnjuYaQAnOjzyDwcsujh+PPT63UaoswgWLIkVV80agHzKo7dt1YwPvFn5nPLcA9kQB0kkO8tDrETeRe6Zh7kHChfsz7+hn9kON3zNrheFOlCr16zBxZV9f+9MXW3la0NtrokWbIf1CgUjKRhJwUgKRgp5l9yn/m7Ifq7Fu2fqtMNIf3fY6tvSsM3Ye8bhFoCzALKpHunJTa8nUlz64lIeWQHw0cC9+rkXP718bXQLtR22tly6krF23Tg8BHAh9VjdKWlw0cE86uvLrL8vlCaTs4iKhc0RxGYewHDI02p0DWrzSd+3U9bZ+WJh85IFzIPQsbrUCJy5b53DzFEvQZixBjjTNcs9fOeSi37/Ua9A6NdzGCnYk77L5mAq5aafa+euGB8bbHNVvGA7bGdswtvs8ti4t9n1ggXbnrqNOHc89bnJzK/X76Q+txHj4ZWioejbFk4uvEDuwypsZbejWXF2AOXzE79j7eVHva77X0GD9QLdJUkKRlIwkoKRFIzU9En/7uxcRwd4OTfbE3NrtMNICkZSMJKCkRSMpGAkBSMpGEnBSApGUjCSfnElaYeRFIykYCQFIykYScFICkbSb/otzq3RDiMpGEnBSApGUjCSgpEUjKRgJAUjKRhJwUhN3yWbvVv9b3yvVzuMpGAkBSMpGEnBSNGnje9dteCaw1q3dhhJwUgKxgDwC1uElG5hrXBnAAAAAElFTkSuQmCC"
});

function SvgIcons8Hospital396({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Hospital396);
export default __webpack_public_path__ + "static/media/icons8-hospital-3-96.9b95c863.svg";
export { ForwardRef as ReactComponent };